export const checkIfIsPresentationPage = (pathname: string): boolean => {
  return pathname.startsWith('/presentation') || pathname.startsWith('/new-presentation');
};
